"use client";

import { createAuthClient } from "better-auth/react";

// Billing is Stripe-only; checkout and the billing portal go through the REST
// endpoints in checkout-client.ts, not a better-auth billing plugin.
export const authClient = createAuthClient({
  baseURL:
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.NEXT_PUBLIC_BETTER_AUTH_URL || "http://localhost:3000",
});

// Type exports for client-side usage
export type AuthClient = typeof authClient;
